<template>
  <div>
    <h4
      :key="columnSpec.key"
      :class="{
        'mb-9 text-center text-2xl font-black text-www-color-neutral-medium-dark': true,
      }"
    >
      {{ data?.title }}
    </h4>
    <div
      v-if="data?.logos?.logos?.length"
      :key="columnSpec.key"
      :class="{
        'logos-wrapper grid w-full items-center justify-items-center lg:gap-4': true,
      }"
      :style="columnSpec.gridStyle"
    >
      <Logo
        v-for="(logo, index) in data?.logos.logos"
        :key="`${columnSpec.key}-${index}`"
        v-bind="logo"
        :index="index"
        :total-items="columnSpec.totalItems"
        :items-in-last-row="columnSpec.itemsInLastRow"
        :last-row-start-column="columnSpec.lastRowStartColumn"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import Logo from './Logo.vue';
import type { LogoBandRefQueryResult } from '~/sanity/types';
interface LogoBandProps {
  data: LogoBandRefQueryResult;
}

const props = defineProps<LogoBandProps>();
const rs = useResponsive().getDefault(); // Get responsive values

const columnSpec = useFlushCompute(() => {
  const totalItems = props?.data?.logos?.logos.length || 0;
  const columnsPerRow: number = rs.isMobile.value ? 3 : props.data?.logosPerRow || 5;
  const itemsInLastRow: number = totalItems % columnsPerRow || columnsPerRow;
  const lastRowStartColumn: number =
    itemsInLastRow < columnsPerRow ? Math.floor((columnsPerRow - itemsInLastRow) / 2) + 1 : 1;
  const gridStyle = {
    gridTemplateColumns: `repeat(${columnsPerRow}, 1fr)`,
  };
  const key = `band-key-${columnsPerRow}-${itemsInLastRow}-${lastRowStartColumn}-${rs.isMobile.value}`;

  return {
    key,
    columnsPerRow,
    itemsInLastRow,
    lastRowStartColumn,
    gridStyle,
    totalItems,
  };
});
</script>
<style scoped></style>
